<app-installer-category-icon [categoryValue]="item[field]?.value"></app-installer-category-icon>
